import { openDealPage } from "@utils/navigation.util";
import { IDealTagResponse } from "@interfaces/responses.interface";
import { TagWrapper } from "./TagWrapper";
import { TagLabel } from "@ui/Content";
import { View } from "@ui/View";

interface Props {
  data: IDealTagResponse;
  isDisabled?: boolean;
  onAdd?: (tag: IDealTagResponse) => void;
  onRemove?: (tag: IDealTagResponse) => void;
  withPlusIcon?: boolean;
  iconOnly?: boolean;
}

export function DealTag({
  data,
  isDisabled = false,
  onAdd,
  onRemove,
  withPlusIcon,
  iconOnly,
}: Props) {
  return (
    <TagWrapper
      data={data}
      isDisabled={isDisabled}
      onRemove={onRemove}
      onRedirect={() => openDealPage(data.object.id)}
      withPlusIcon={withPlusIcon}
      onAdd={onAdd}
    >
      <div
        className="m-1 h-3 w-3 flex-shrink-0 rounded"
        style={{ background: data.object.stage_color }}
      />

      <View.Condition if={!iconOnly}>
        <TagLabel>{data.object.title}</TagLabel>
      </View.Condition>
    </TagWrapper>
  );
}
